import { css } from '@emotion/react';
import { Icon, IconName } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { OPERATORY_ALL_ICONS } from '../constant';

interface Props {
  color: string;
  value: IconName;
  onChange: (iconName: IconName) => void;
}

export const AvatarIconList = ({ value, onChange, color }: Props) => {
  return (
    <div css={iconListContainer}>
      {OPERATORY_ALL_ICONS.map((iconName) => (
        <div key={iconName} css={iconSelectionContainer(value === iconName)}>
          <div onClick={() => onChange(iconName)} css={iconSelectionStyle(value === iconName, color)}>
            <Icon color='default' name={iconName} />
          </div>
        </div>
      ))}
    </div>
  );
};

const iconListContainer = css({
  display: 'flex',
  flexWrap: 'wrap',
  paddingTop: theme.spacing(1),
});

const iconSelectionStyle = (isSelected: boolean, selectionColor: string) =>
  css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    width: theme.spacing(3.5),
    height: theme.spacing(3.5),
    borderRadius: theme.borderRadius.small,
    padding: theme.spacing(0.5),
    ...(isSelected && {
      background: selectionColor,
    }),
  });

const iconSelectionContainer = (isSelected: boolean) =>
  css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    borderRadius: theme.borderRadius.medium,
    width: theme.spacing(4.5),
    height: theme.spacing(4.5),
    ...(isSelected && {
      border: `2px solid ${theme.colors.primary50}`,
    }),
  });
